export default {
  about_badge: '// О компании',
  about_title1: 'RHEINMETALL AG —',
  about_title2: 'ЛИДЕР ЕВРОПЕЙСКОЙ',
  about_title3: 'ОБОРОНЫ',
  about_desc1: 'Основанная в 1889 году, Rheinmetall AG является крупнейшим немецким оборонным концерном и одним из ведущих мировых производителей военной техники и боеприпасов. Штаб-квартира расположена в Дюссельдорфе, Германия.',
  about_desc2: 'В условиях резкого роста оборонных бюджетов стран НАТО и Европы, Rheinmetall демонстрирует рекордные финансовые показатели. Портфель заказов превысил <strong>€50 миллиардов</strong> — это гарантированная загрузка производства до 2030 года и стабильный доход для инвесторов.',
  about_tags: 'Бронетехника,Артиллерия,Боеприпасы,Электроника,Кибербезопасность',
  about_img_caption: 'Портфель заказов до 2030 года',
  about_stat1: 'Год основания',
  about_stat2: 'Выручка 2024',
  about_stat3: 'Сотрудников',
  about_stat4: 'Стран-партнёров',
  weapons_badge: '// Производимое вооружение',
  weapons_title1: 'ВООРУЖЕНИЕ',
  weapons_title2: 'НОВОГО ПОКОЛЕНИЯ',
  weapons_subtitle: 'Полный цикл производства от боеприпасов до бронетехники. Поставки в 50+ стран мира. Каждый контракт — это ваша прибыль.',
  weapons_specs_label: 'Характеристики',
  weapons_hide: 'Скрыть',
  weapons_show: 'Характеристики',
  w1_title: 'Основные боевые танки', w1_desc: 'Лучший в мире основной боевой танк. Leopard 2A8 оснащён активной защитой Trophy, новейшей системой управления огнём и 120-мм гладкоствольной пушкой Rh-120. Заказы от 12 стран НАТО.', w1_tag: 'Бронетехника', w1_rev: '€8.2 млрд заказов',
  w2_title: 'Самоходная гаубица', w2_desc: 'Самая точная самоходная артиллерийская установка в мире. Дальность стрельбы до 67 км с управляемыми снарядами. Используется армиями Германии, Нидерландов, Греции, Италии и Украины.', w2_tag: 'Артиллерия', w2_rev: '€3.5 млрд заказов',
  w3_title: 'Боевая машина пехоты', w3_desc: 'Новейшая БМП нового поколения с модульной архитектурой. Вооружена 35-мм автоматической пушкой Wotan и противотанковыми ракетами Spike LR2. Контракты с Венгрией, Австралией, Словакией.', w3_tag: 'БМП', w3_rev: '€5.1 млрд заказов',
  w4_title: 'Зенитный ракетный комплекс', w4_desc: 'Революционная система противовоздушной обороны для защиты от дронов, вертолётов и низколетящих самолётов. 30-мм пушка с темпом стрельбы 1200 выстр/мин. Интегрируется на любую платформу.', w4_tag: 'ПВО', w4_rev: '€2.8 млрд заказов',
  w5_title: 'Боеприпасы 155-мм', w5_desc: 'Rheinmetall — крупнейший производитель артиллерийских боеприпасов в Европе. Производство снарядов 155-мм увеличено в 8 раз. Контракты с 20+ странами НАТО на поставку миллионов снарядов.', w5_tag: 'Боеприпасы', w5_rev: '€4.7 млрд заказов',
  w6_title: 'Зенитный танк Gepard', w6_desc: 'Легендарная зенитная самоходная установка с двумя 35-мм пушками. Доказала эффективность против дронов и крылатых ракет в реальных боевых условиях. Поставки Украине стали переломным моментом.', w6_tag: 'ЗСУ', w6_rev: '€1.9 млрд заказов',
  conflicts_badge: '// Участие в конфликтах',
  conflicts_title1: 'КРИТИЧЕСКАЯ РОЛЬ',
  conflicts_title2: 'В ГЛОБАЛЬНОЙ БЕЗОПАСНОСТИ',
  conflicts_subtitle: 'Rheinmetall поставляет технику в горячие точки и зоны конфликтов. Каждый выстрел — это ваш доход. Война — это бизнес, и мы предлагаем вам стать его частью.',
  conflicts_deliveries: 'Поставки',
  conflicts_hide: 'Скрыть',
  conflicts_more: 'Подробнее',
  conflicts_why_label: 'Почему это выгодно',
  conflicts_why_title: 'ВОЙНА — ЭТО РОСТ АКЦИЙ',
  conflicts_why_desc: 'Оборонные бюджеты стран НАТО выросли на <strong>+40% за 2 года</strong>. Германия увеличила военные расходы до €100 млрд. Польша тратит 4% ВВП на оборону. Каждый конфликт — это новые контракты для Rheinmetall и новая прибыль для инвесторов.',
  stat_stocks: 'Рост акций за 3 года',
  stat_backlog: 'Портфель заказов',
  stat_ammo: 'Рост производства снарядов',
  c1_region: 'Украина', c1_status: 'Активно', c1_desc: 'Крупнейший покупатель техники Rheinmetall. Поставлены сотни единиц Leopard 2, Marder, Gepard. Открыт совместный завод по производству бронетехники на территории Украины.',
  c2_region: 'Польша', c2_status: 'Контракт подписан', c2_desc: 'Польша реализует крупнейшую программу перевооружения в истории страны. Заказаны 800 танков K2 с башнями Rheinmetall, 500 БМП Lynx KF41 и тысячи единиц артиллерии.',
  c3_region: 'Германия', c3_status: 'Долгосрочный', c3_desc: 'Бундесвер проводит масштабную модернизацию. Заказаны 18 PzH 2000, 123 Leopard 2A8, 143 Lynx KF41. Бюджет обороны Германии вырос до €100 млрд — рекорд за всю историю.',
  c4_region: 'Венгрия', c4_status: 'Производство', c4_desc: 'Венгрия строит завод Rheinmetall на своей территории. Заказаны 218 Lynx KF41 — крупнейший контракт на БМП в истории Европы. Производство локализовано.',
  c5_region: 'Австралия', c5_status: 'Новый контракт', c5_desc: 'Австралия выбрала Lynx KF41 для замены устаревших M113. Контракт на 450 машин с производством в Австралии. Rheinmetall открывает завод в Квинсленде.',
  c6_region: 'Румыния', c6_status: 'Переговоры', c6_desc: 'Румыния планирует закупку 300 Lynx KF41 и 54 PzH 2000. Страна граничит с Украиной и активно наращивает военный потенциал при поддержке НАТО.',
  calc_badge: '// Калькулятор прибыли',
  calc_title1: 'РАССЧИТАЙТЕ',
  calc_title2: 'ВАШУ ПРИБЫЛЬ',
  calc_subtitle: 'Прозрачная система доходности без скрытых комиссий. Все сделки за 3 дня.',
  calc_plan1: 'Старт',
  calc_plan2: 'Оптимум',
  calc_plan3: 'Премиум',
  calc_popular: 'Популярный',
  calc_per_year: '%',
  calc_custom_label: 'Своя сумма (€)',
  calc_custom_placeholder: 'Мин. €',
  calc_period_label: 'Срок сделки: 3 дня',
  calc_period_months: '',
  calc_profit_label: 'Ваша прибыль за 3 дня',
  calc_profit_months: '',
  calc_total_label: 'Итоговая сумма: ',
  calc_invested: 'Вложено',
  calc_rate: 'Ставка',
  calc_per_yr: '%',
  calc_cta: 'Открыть инвестиционный счёт',
  calc_feat1_title: 'Страхование депозитов', calc_feat1_desc: 'Ваши средства защищены европейской системой страхования вкладов',
  calc_feat2_title: 'Ежеквартальные выплаты', calc_feat2_desc: 'Получайте прибыль каждые 3 месяца на ваш счёт',
  calc_feat3_title: 'Юридическая защита', calc_feat3_desc: 'Договор по немецкому праву, нотариально заверенный',
  contact_badge: '// Контакты',
  contact_title1: 'НАЧНИТЕ',
  contact_title2: 'ИНВЕСТИРОВАТЬ СЕГОДНЯ',
  contact_subtitle: 'Оставьте заявку и наш менеджер свяжется с вами в течение 24 часов для открытия инвестиционного счёта.',
  contact_why_title: 'Почему выбирают нас',
  contact_r1_title: 'Лицензированный брокер', contact_r1_desc: 'Деятельность регулируется BaFin (Германия) и FCA (Великобритания)',
  contact_r2_title: 'Безопасность средств', contact_r2_desc: 'Средства хранятся на сегрегированных счетах в Deutsche Bank',
  contact_r3_title: 'Персональный менеджер', contact_r3_desc: 'Индивидуальное сопровождение на всём сроке инвестиций',
  contact_r4_title: 'Быстрый старт', contact_r4_desc: 'Открытие счёта за 24 часа, первые выплаты через 3 месяца',
  contact_address_label: 'Адрес',
  contact_form_title: 'Заявка на инвестиции',
  contact_name_label: 'Ваше имя *',
  contact_name_placeholder: 'Иван Иванов',
  contact_email_label: 'Email *',
  contact_phone_label: 'Телефон',
  contact_phone_placeholder: '+7 999 000 00 00',
  contact_amount_label: 'Сумма инвестиций',
  contact_amount_placeholder: 'Выберите план',
  contact_amount_opt1: '€3,000 — 24%',
  contact_amount_opt2: '€5,000 — 29%',
  contact_amount_opt3: '€10,000 — 37%',
  contact_amount_opt4: 'Индивидуальная сумма',
  contact_msg_label: 'Сообщение',
  contact_msg_placeholder: 'Ваши вопросы или пожелания...',
  contact_submit: 'Отправить заявку',
  contact_sending: 'Отправка...',
  contact_success: 'Заявка отправлена! Мы свяжемся с вами в течение 24 часов.',
  contact_error: 'Ошибка отправки. Попробуйте ещё раз или напишите нам напрямую.',
  contact_privacy: 'Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности',
  footer_desc: 'Инвестиционный портал Rheinmetall AG. Вкладывайте в лидера европейской оборонной промышленности.',
  footer_company: 'Компания',
  footer_investors: 'Инвесторам',
  footer_products: 'Продукция',
  footer_about: 'О компании',
  footer_history: 'История',
  footer_production: 'Производство',
  footer_news: 'Новости',
  footer_plans: 'Тарифы',
  footer_calculator: 'Калькулятор',
  footer_docs: 'Документы',
  footer_faq: 'FAQ',
  footer_armor: 'Бронетехника',
  footer_artillery: 'Артиллерия',
  footer_ammo: 'Боеприпасы',
  footer_air: 'ПВО',
  footer_rights: '© 2025 Rheinmetall Investment Portal. Все права защищены.',
  footer_privacy: 'Политика конфиденциальности',
  footer_terms: 'Условия использования',
  footer_disclaimer: 'Инвестирование сопряжено с рисками. Прошлые результаты не гарантируют будущих доходов. Данный сайт носит информационный характер и не является публичной офертой.',
  toast_earned: 'заработал по контракту',
  toast_period: 'за 3 дня',

  // Navigation
  nav: {
    about: 'О компании',
    weapons: 'Вооружение',
    conflicts: 'Конфликты',
    calculator: 'Калькулятор',
    contact: 'Контакты',
  },

  // Hero Section
  hero: {
    badge: 'Открыто для инвесторов',
    title1: 'ИНВЕСТИЦИИ',
    title2: 'В БУДУЩЕЕ',
    title3: 'ОБОРОНЫ',
    description: 'Rheinmetall AG — крупнейший оборонный концерн Европы. Вложите от €3 000 и получайте до {{return}} за 3 дня.',
    stat1: 'Прибыль до 37% за 3 дня',
    stat2: 'Контракты на €50+ млрд до 2030 года',
    stat3: 'Рост акций +280% за 3 года',
    cta1: 'Рассчитать доход',
    cta2: 'Узнать больше',
    scroll: 'Прокрутите вниз',
    turretLabel: 'Leopard 2A7+',
    turretHint: 'Башня · нажмите для выстрела',
  },

  // About Section
  about: {
    label: 'О компании',
    title: 'RHEINMETALL AG',
    subtitle: 'Лидер обороны Европы',
    description: 'Немецкий промышленный конгломерат, мировой лидер в производстве бронетехники и артиллерийских систем. С начала войны в Украине компания увеличила производство на 400%.',
    stats: {
      founded: 'Основана',
      employees: 'Сотрудников',
      revenue: 'Выручка',
      contracts: 'Заказов',
    },
  },

  // Weapons Section
  weapons: {
    label: 'Военная техника',
    title: 'БОЕВЫЕ СИСТЕМЫ',
    subtitle: 'Современная бронетехника и артиллерия, составляющая основу сил НАТО',
    items: {
      leopard: {
        name: 'Leopard 2A7+',
        desc: 'Основной боевой танк — флагман европейских бронесил',
      },
      lynx: {
        name: 'Lynx KF41',
        desc: 'Боевая машина пехоты нового поколения',
      },
      puma: {
        name: 'PUMA',
        desc: 'Тяжёлая боевая машина пехоты',
      },
      panzerhaubitze: {
        name: 'Panzerhaubitze 2000',
        desc: 'Самоходная гаубица с дальностью 40 км',
      },
      fuchs: {
        name: 'Fuchs',
        desc: 'Бронетранспортёр',
      },
      boxer: {
        name: 'Boxer',
        desc: 'Модульная боевая машина',
      },
    },
  },

  // Conflicts Section
  conflicts: {
    label: 'Геополитика',
    title: 'ЗОНЫ КОНФЛИКТОВ',
    subtitle: 'Текущие военные конфликты, стимулирующие рост оборонной промышленности',
    ukraine: {
      title: 'Война в Украине',
      description: 'С 2022 года Rheinmetall поставил более 200 танков Leopard и развернул локальное производство. Контракты на €8,5 млрд.',
    },
    middleEast: {
      title: 'Ближний Восток',
      description: 'Поставки систем ПВО и бронетехники в Катар, ОАЭ и Саудовскую Аравию. Контракты на €12 млрд.',
    },
    baltic: {
      title: 'Прибалтика',
      description: 'Программа усиления НАТО. Новые производства в Литве и Румынии. Инвестиции €2,5 млрд.',
    },
  },

  // Calculator Section
  calculator: {
    label: 'Калькулятор инвестиций',
    title: 'РАССЧИТАЙТЕ СВОЙ ДОХОД',
    subtitle: 'Рассчитайте потенциальную прибыль от инвестиций в акции Rheinmetall AG',
    amount: 'Сумма инвестиций',
    period: 'Срок инвестирования',
    years: '{{years}} лет',
    result: 'Прогнозируемая прибыль',
    total: 'Итоговая сумма',
    profit: 'Чистая прибыль',
    cta: 'Начать инвестировать',
  },

  // Contact Section
  contact: {
    label: 'Свяжитесь с нами',
    title: 'СВЯЖИТЕСЬ С НАМИ',
    subtitle: 'Наши инвестиционные консультанты готовы ответить на ваши вопросы',
    form: {
      name: 'Ваше имя',
      email: 'Email',
      phone: 'Телефон',
      amount: 'Сумма инвестиций',
      message: 'Сообщение',
      submit: 'Отправить заявку',
      success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
    },
  },

  // Testimonials
  testimonials: {
    badge: '// Отзывы инвесторов',
    title1: 'ЧТО ГОВОРЯТ',
    title2: 'НАШИ ИНВЕСТОРЫ',
    subtitle: 'Реальные результаты реальных инвесторов по всей Европе. Без лиц — только цифры.',
    from: 'из',
    stat1: 'Активных инвесторов',
    stat2: 'Выплачено всего',
    stat3: 'Макс. доходность',
    stat4: 'Стран',
    t1: {
      name: 'М. Краузе',
      role: 'Частный инвестор · Франкфурт',
      text: 'Сначала был скептиком — оборонные инвестиции казались слишком нишевыми. Но после первой сделки, закрытой за 3 дня с доходностью 37%, я удвоил позицию. Rheinmetall — это не просто компания, это машина по печатанию денег в военное время.',
    },
    t2: {
      name: 'И. Димитров',
      role: 'Предприниматель · София',
      text: 'Пробовал многие платформы — крипта, форекс, недвижимость. Ничто не сравнится со стабильностью здесь. Три сделки, три победы. Менеджер всё объяснил чётко, договор по немецкому праву. Сплю спокойно.',
    },
    t3: {
      name: 'П. Вишневский',
      role: 'Инженер · Варшава',
      text: 'Польша перевооружается рекордными темпами — я решил на этом заработать. Вложил €12 000, получил €16 440 за 3 дня. Теперь рассказываю всем коллегам. Это самая логичная инвестиция нашего времени.',
    },
    t4: {
      name: 'Л. Руссо',
      role: 'Владелец бизнеса · Милан',
      text: 'В Италии говорят: инвестируй туда, куда текут деньги. А деньги сейчас текут в оборону. Вложил €20 000 и получил €27 400 обратно. Процесс был плавным, прозрачным, профессиональным. Настоятельно рекомендую.',
    },
    t5: {
      name: 'Э. Хансен',
      role: 'Финансовый аналитик · Осло',
      text: 'Как аналитик я ежедневно отслеживаю акции оборонных компаний. Фундаментальные показатели Rheinmetall исключительны — портфель €50 млрд, поддержка НАТО, рекордная маржа. Этот портал даёт розничным инвесторам доступ к институциональной доходности.',
    },
  },

  // Footer
  footer: {
    rights: '© {{year}} Rheinmetall AG. Все права защищены.',
    disclaimer: 'Инвестиции в ценные бумаги связаны с рисками. Прошлая доходность не гарантирует будущих результатов.',
  },
};